import { AxiosError } from 'axios';
import { t } from 'i18next';
import { FieldValues, Path, UseFormSetError } from 'react-hook-form';

import { ErrorStatus } from '@shared/consts/errorStatus';
import { i18nNameSpace } from '@shared/consts/i18n';
import { ApiError } from '@shared/utils/interfaces/error';
import { translateApiErrorFieldPath } from '@shared/utils/translateApiErrorFieldPath.ts';

type ErrorFieldPath<T> = `root.${string}` | 'root' | Path<T>;

const displayApiErrorsOnFormFields = <T extends FieldValues>(setError: UseFormSetError<T>, error: unknown) => {
  const axiosError = error as AxiosError<ApiError>;

  if (axiosError) {
    const apiError = axiosError.response?.data;

    if (apiError?.status === ErrorStatus.VALIDATION_ERROR) {
      apiError.details?.forEach((errorDetail) => {
        const rawFieldPath =
          typeof errorDetail.i18n.props.fieldPath === 'string'
            ? errorDetail.i18n.props.fieldPath
            : errorDetail.fieldPath;

        setError(errorDetail.fieldPath as ErrorFieldPath<T>, {
          type: 'manual',
          message: t(errorDetail.i18n.key, {
            ...errorDetail.i18n.props,
            fieldPath: translateApiErrorFieldPath(rawFieldPath),
            ns: i18nNameSpace.API,
          }),
        });
      });
    }
  }
};

export { displayApiErrorsOnFormFields };
